<!-- <input type="date" > -->
<div #flatpickrEl class="ag-input-wrapper custom-date-filter" role="presentation">
        <input type='text' data-input />
        <a class='input-button' title='clear' data-clear>
            <i class='fa fa-times'></i>
        </a>
    </div>